import { render, staticRenderFns } from "./OrderCreatorService.vue?vue&type=template&id=5f283b5f&scoped=true&"
import script from "./OrderCreatorService.vue?vue&type=script&lang=js&"
export * from "./OrderCreatorService.vue?vue&type=script&lang=js&"
import style0 from "./OrderCreatorService.vue?vue&type=style&index=0&id=5f283b5f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f283b5f",
  null
  
)

export default component.exports